export enum TIMEZONES {
    CANADA_PACIFIC = 'Canada/Pacific',
    CANADA_MOUNTAIN = 'Canada/Mountain',
}

export const TIMEZONE_OPTIONS = [
    { label: 'PT', value: TIMEZONES.CANADA_PACIFIC },
    { label: 'MT', value: TIMEZONES.CANADA_MOUNTAIN },
];
